/*
 * Endless auto-scrolling product rail with drag (sections/vx-products.liquid, layout "rail").
 * The track holds the products twice; when the scroll passes the first copy it jumps back by exactly
 * one copy's width, so the loop never shows a seam. Touch scrolls natively; mouse drags by hand.
 * Pauses while hovered, dragged or touched, resumes 1.5 s later. Off for prefers-reduced-motion.
 *
 * LT v2 speed (2026-10-13): the VigorX version ran a requestAnimationFrame loop from DOMContentLoaded
 * forever — off-screen too — reading offsetParent and writing scrollLeft every frame (171 ms of
 * scripting in the Lighthouse trace before anything else had settled). Now the loop starts only after
 * the page has loaded, runs only while the rail is on screen (IntersectionObserver), and the copy
 * width is measured once per resize instead of every frame.
 */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SPEED = 0.035; // px per ms (~35 px/s)

  function init(track) {
    if (track.__vxm) return;
    track.__vxm = true;
    var clones = track.querySelectorAll('.vx-products__item--clone a');
    for (var i = 0; i < clones.length; i++) clones[i].setAttribute('tabindex', '-1');

    var paused = false, visible = false, running = false, resumeT = 0, last = 0, pos = 0;
    var dragging = false, startX = 0, startPos = 0, moved = 0, copyW = 0;

    function measure() {
      var first = track.querySelector('.vx-products__item--clone');
      var a = track.querySelector('.vx-products__item');
      copyW = first && a ? first.offsetLeft - a.offsetLeft : track.scrollWidth / 2;
    }
    function wrap() {
      if (copyW <= 0) return;
      if (track.scrollLeft >= copyW) track.scrollLeft -= copyW;
      else if (track.scrollLeft <= 0 && dragging) track.scrollLeft += copyW;
    }
    function pause() { paused = true; clearTimeout(resumeT); }
    function resumeSoon() { clearTimeout(resumeT); resumeT = setTimeout(function () { paused = false; pos = track.scrollLeft; start(); }, 1500); }

    function tick(t) {
      if (!visible || paused || reduce) { running = false; last = 0; return; }
      if (last) {
        pos += (t - last) * SPEED;
        if (copyW > 0 && pos >= copyW) pos -= copyW;
        track.scrollLeft = pos;
      }
      last = t;
      requestAnimationFrame(tick);
    }
    function start() {
      if (running || !visible || paused || reduce) return;
      running = true; last = 0; pos = track.scrollLeft;
      requestAnimationFrame(tick);
    }

    track.addEventListener('mouseenter', pause);
    track.addEventListener('mouseleave', function () { if (!dragging) resumeSoon(); });
    track.addEventListener('touchstart', pause, { passive: true });
    track.addEventListener('touchend', resumeSoon, { passive: true });
    track.addEventListener('scroll', function () { if (paused) wrap(); }, { passive: true });

    // mouse drag (touch uses native scrolling)
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dragging = true; moved = 0; startX = e.clientX; startPos = track.scrollLeft;
      pause(); track.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      moved = Math.max(moved, Math.abs(dx));
      track.scrollLeft = startPos - dx;
      wrap();
    });
    window.addEventListener('pointerup', function () {
      if (!dragging) return;
      dragging = false; track.classList.remove('is-dragging'); resumeSoon();
    });
    // a drag must not open the product under the cursor
    track.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    var rt = 0;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(measure, 150); }, { passive: true });
    measure();

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[entries.length - 1].isIntersecting;
        if (visible) { measure(); start(); }
      }, { rootMargin: '100px 0px' }).observe(track);
    } else {
      visible = true; start();
    }
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-vx-marquee]'), init); }
  // nothing moves before the page has loaded: the rail is never above the fold
  if (document.readyState === 'complete') boot();
  else window.addEventListener('load', boot, { once: true });
  document.addEventListener('shopify:section:load', boot);
})();
